import { create } from 'zustand';

const initialState = {
	notificationChatCount: null,
};

const notificationStore = (set) => ({
	...initialState,
	setNotificationCount: (notificationChatCount) =>
		set(
			(state) => ({
				...state,
				notificationChatCount,
			}),
			false,
			'setNotificationChatCount'
		),
});

const useNotificationCount = create(notificationStore);

export default useNotificationCount;
